import React from 'react'
import {Svg, CommonSvgProps, commonPropTypes, commonDefaultProps} from '@modifi/ui'

type NewsIconProps = CommonSvgProps

const NewsIcon: React.FC<NewsIconProps> = React.forwardRef<SVGSVGElement, NewsIconProps>(
  (props, ref) => (
    <Svg viewBox="0 0 32 33" {...props} ref={ref} color="none">
      <path
        d="M5.20337 31.5254H26.6269C28.1418 31.5254 29.3744 30.2928 29.3744 28.7778V2.555C29.3744 2.24144 29.1203 1.98706 28.8065 1.98706H7.38295C7.06913 1.98706 6.81501 2.24144 6.81501 2.555V7.59196H3.02985C2.71603 7.59196 2.46191 7.84634 2.46191 8.1599V28.778C2.46191 30.2929 3.6916 31.5255 5.20362 31.5255L5.20337 31.5254ZM7.95089 3.12298H28.2383V28.7778C28.2383 29.6664 27.5153 30.3894 26.6267 30.3894H7.42734C7.43368 30.3804 7.43817 30.3701 7.44477 30.3614C7.51478 30.2623 7.57897 30.1593 7.63576 30.0513C7.64659 30.0307 7.65583 30.0093 7.66614 29.9882C7.71553 29.8883 7.75886 29.7853 7.79584 29.6791C7.80244 29.6601 7.81037 29.6416 7.81671 29.6223C7.85501 29.5039 7.88407 29.3819 7.90599 29.2572C7.91101 29.2292 7.91471 29.2012 7.91894 29.173C7.93769 29.0438 7.95064 28.9125 7.95064 28.778L7.95089 3.12298ZM3.59755 8.72819H6.81473V28.7782C6.81473 29.6666 6.09175 30.3896 5.20337 30.3896C4.31789 30.3896 3.59782 29.6666 3.59782 28.7782L3.59755 8.72819Z"
        fill="#51565C"
      />
      <path
        d="M15.1505 9.54703H25.0798C25.3936 9.54703 25.6477 9.29265 25.6477 8.97909C25.6477 8.66554 25.3936 8.41115 25.0798 8.41115L15.1505 8.41089C14.8366 8.41089 14.5825 8.66527 14.5825 8.97883C14.5825 9.29265 14.8369 9.54703 15.1505 9.54703V9.54703Z"
        fill="#53A2D9"
      />
      <path
        d="M11.9708 13.4357H25.0819C25.3957 13.4357 25.6498 13.1813 25.6498 12.8678C25.6498 12.5542 25.3957 12.2998 25.0819 12.2998L11.9708 12.2996C11.657 12.2996 11.4028 12.5539 11.4028 12.8675C11.4026 13.1813 11.657 13.4357 11.9708 13.4357V13.4357Z"
        fill="#7BB835"
      />
      <path
        d="M25.0795 16.1879H15.1495C14.8357 16.1879 14.5815 16.4423 14.5815 16.7558C14.5815 17.0694 14.8357 17.3237 15.1495 17.3237H25.0788C25.3926 17.3237 25.6468 17.0694 25.6468 16.7558C25.647 16.4423 25.3929 16.1879 25.0791 16.1879H25.0795Z"
        fill="#53A2D9"
      />
      <path
        d="M11.2506 21.2128H25.0798C25.3936 21.2128 25.6477 20.9584 25.6477 20.6449C25.6477 20.3313 25.3936 20.0769 25.0798 20.0769L11.2506 20.0767C10.9367 20.0767 10.6826 20.331 10.6826 20.6446C10.6826 20.9584 10.9367 21.2128 11.2506 21.2128V21.2128Z"
        fill="#53A2D9"
      />
      <path
        d="M25.0818 23.965H12.5191C12.2053 23.965 11.9512 24.2194 11.9512 24.5329C11.9512 24.8465 12.2053 25.1008 12.5191 25.1008H25.0818C25.3956 25.1008 25.6497 24.8465 25.6497 24.5329C25.6497 24.2194 25.3956 23.965 25.0818 23.965V23.965Z"
        fill="#7BB835"
      />
    </Svg>
  )
)

NewsIcon.propTypes = commonPropTypes
NewsIcon.defaultProps = commonDefaultProps

export default NewsIcon
